import { asyncHandler } from '../../async-handler';
import store from '../../../../store/store';
import { RequestInfo } from '../../../../interfaces/RequestInfo';
import { TARA_CUSTOM_GRAPH_UPDATE_API } from '../../../constants/central-api';
import { applicationJSONBodyBuilder } from '../../../utils/body-builder';

export default async function update_custom_graph_notification_api_call(
  id: string | number,
  is_notification: boolean
): Promise<boolean | null> {
  const shop_slug = store.getState().user.company.shop_slug;
  const accessToken = store.getState().auth.authorization.accessToken;
  const isWhiteLabel = store.getState().UI?.isWhiteLabel;
  const sellerToken = isWhiteLabel
    ? accessToken?.currentWhiteLabelSellerToken
    : accessToken?.sellerToken;

  const requestInfo: RequestInfo = {
    url: TARA_CUSTOM_GRAPH_UPDATE_API(shop_slug, id),
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
    body: applicationJSONBodyBuilder({ is_notification }),
  };

  const actionType = 'UPDATE_CUSTOM_GRAPH_NOTIFICATION';
  const customMsg = 'Custom graph notification flag updated.';
  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );
  const response = res?.data;

  if (res.actionType === actionType && response?.success === true) {
    return true;
  }
  return null;
}
